import { jsx as t, jsxs as X } from "react/jsx-runtime";
import h from "clsx";
import { C as $, a0 as L, ak as K, am as T, aE as ut, i as kt, p as nt, j as i, t as st, aD as gt, aV as St, bB as Pt, Q as ft, T as $t, an as rt, S as it, aX as bt, G, m as At, k as et, aW as Bt, aA as Vt, bZ as Dt, bd as Lt, aj as Wt, az as Ht } from "./helpers-458d7e27.js";
import { T as at, i as Q, s as Yt, a as Ut, D as jt, M as qt } from "./TextHeaderInner-7887aa3a.js";
import { useRef as Nt, forwardRef as Xt } from "react";
import { a as Ct } from "./TextGroup-dd19925e.js";
import { M as Kt } from "./MinimalTextGroup-0c5b3b52.js";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
import "./MinimalImageFrame-6a4f63a6.js";
const Qt = {
  "custom-media-frame-animation-type-default": "_custom-media-frame-animation-type-default_s9709_3",
  "custom-media-frame-scale-up-animation": "_custom-media-frame-scale-up-animation_s9709_53",
  "video-frame-wrapper": "_video-frame-wrapper_s9709_6"
}, xt = "CustomMediaFrame", ot = new $(xt, Qt), Zt = ({
  animationType: o
}) => {
  if (o !== "default")
    return {
      motionFeel: "Expressive",
      motionTypePreset: "scaleUp",
      motionIntensity: "sm"
    };
}, zt = L.div, Jt = ({ children: o }) => {
  const r = Nt(null), { scrollYProgress: a } = K({
    target: r,
    offset: ["end end", "end start"]
  }), n = T(a, [0, 1], [1, 1.5]);
  return /* @__PURE__ */ t(
    zt,
    {
      className: ot.getElementClassName("scale-up-animation"),
      ref: r,
      style: ut({
        "--image-scale": n
      }),
      children: o
    }
  );
}, Ft = ({
  animationType: o = "default",
  mediaFrameProps: r
}) => {
  const a = h(
    ot.getComponentClassName(),
    ot.getPropsValueClassName("animation-type", o)
  ), n = () => /* @__PURE__ */ t(
    nt,
    {
      className: a,
      maxSrcSetWidth: 3301,
      ...r,
      analyticsCompName: xt
    }
  );
  if (o === "default")
    return n();
  const s = Zt({ animationType: o });
  return /* @__PURE__ */ t(kt, { motionOptions: s, children: /* @__PURE__ */ t(Jt, { children: n() }) });
}, te = () => ({
  options: {
    rowStart: i.auto,
    columnStart: i.leftInner,
    columnEnd: i.rightInner
  }
}), ee = () => ({
  options: {
    columnStart: i.leftInner,
    columnEnd: i.rightInner
  }
}), oe = () => ({
  options: {
    rowStart: i.auto,
    columnStart: i.leftOuter,
    columnEnd: i.rightOuter
  }
}), ne = () => ({
  options: {
    topSpacing: "none"
  }
});
const D = "FeaturedStackSection", U = new $(D), se = ({
  alignment: o,
  topSpacer: r,
  bottomSpacer: a,
  disclosureType: n,
  headline: s,
  mediaFrame: e,
  textGroup: l,
  className: p,
  componentId: c,
  isParallaxEnabled: m,
  theme: d = "white",
  sectionTransitionConfig: N = bt,
  componentOrderIdx: v = 0
}) => {
  const C = st(), {
    ref: x,
    sectionId: I,
    disableTransitions: w
  } = gt(D, v), { scrollProgress: y } = St(I), R = T(y, [0, 1], [1, 0]), M = T(y, [0, 1], [0, -100]), { stickyStyles: E } = Pt(
    x,
    y
  ), { isDisabled: S } = N, u = w || C || S, A = u ? { opacity: 1, y: 0 } : { opacity: R, y: M, ...E }, { scrollYProgress: _ } = K({
    target: x,
    offset: ["start end", "end start"]
  }), [g, O] = ft([
    "Below MD",
    "Below LG"
  ]), Z = h(
    U.getComponentClassName(),
    p,
    $t.getThemeClassName(d)
  ), W = h(p, {
    [U.getElementClassName("mobileContainer")]: g
  }), B = !m || C, z = (e == null ? void 0 : e.type) === "Video" ? e.video : void 0, H = (e == null ? void 0 : e.type) === "Image" ? e.image : void 0, J = te(), f = ee(), k = oe(), Mt = ne(), Ot = {
    options: {
      topSpacing: r,
      bottomSpacing: a,
      rowsGap: "none"
    }
  }, lt = "clamp(4rem, -2.4rem + 10vw, 9.6rem)", Y = "clamp(2rem, -1.2rem + 5vw, 4.8rem)", Tt = T(
    _,
    [0.15, 0.3],
    [lt, Y]
  ), F = {};
  O || B ? F.marginBottom = Y : F.marginBottom = Tt;
  const vt = T(
    _,
    [0.45, 0.6],
    [lt, Y]
  ), tt = {};
  O || B ? tt.marginTop = Y : tt.marginTop = vt;
  const wt = "16:9", Rt = (b) => {
    let V = b;
    return Q(b) || (V = {
      textGroup: b
    }), /* @__PURE__ */ t(G, { ...J, children: /* @__PURE__ */ t(L.div, { style: F, children: /* @__PURE__ */ t(
      at,
      {
        className: U.getElementClassName("headlineContainer"),
        ...V,
        textGroup: {
          ...V.textGroup,
          alignment: o,
          analyticsCompName: D
        }
      }
    ) }) });
  }, Et = (b) => /* @__PURE__ */ t(
    G,
    {
      ...k,
      className: W,
      role: "img",
      children: /* @__PURE__ */ t(
        nt,
        {
          ...b,
          analyticsCompName: D,
          roundedCorners: !0
        }
      )
    }
  ), ht = (b) => /* @__PURE__ */ t(
    G,
    {
      ...k,
      className: W,
      role: "img",
      "aria-label": b.imageAltText,
      children: /* @__PURE__ */ t(
        At,
        {
          ...b,
          fetchPriority: "high",
          parallaxFactor: 5,
          disableParallax: B,
          mediaRatio: e.mediaRatio || wt
        }
      )
    }
  ), _t = (b) => {
    const V = (pt) => {
      pt.target.scrollIntoView({ block: "end" }), setTimeout(() => {
        pt.target.scrollIntoView({ block: "end", behavior: "smooth" });
      }, 100);
    };
    return /* @__PURE__ */ t(
      G,
      {
        ...f,
        className: U.getElementClassName("textContainer"),
        children: /* @__PURE__ */ t(L.div, { style: tt, onFocus: V, children: /* @__PURE__ */ t(
          Ct,
          {
            ...b,
            analyticsCompName: D,
            alignment: o
          }
        ) })
      }
    );
  };
  return /* @__PURE__ */ t(rt, { children: /* @__PURE__ */ X(
    it,
    {
      className: Z,
      theme: d,
      disclosure: n,
      disclosureGridItemProps: Mt,
      id: c,
      ref: x,
      motion: u ? "none" : "custom",
      motionProps: { style: A },
      ...Ot,
      children: [
        s && Rt(s),
        z && Et(e),
        H && ht(H),
        l && _t(l)
      ]
    }
  ) });
}, re = () => ({
  options: {
    columnStart: i.leftInner,
    columnEnd: i.rightInner,
    bottomSpacing: "1rem"
  },
  lgOptions: {
    columnStart: i.leftInner,
    columnEnd: et.inner7,
    bottomSpacing: "none"
  }
}), ie = () => ({
  options: {
    columnStart: i.leftInner,
    columnEnd: i.rightInner
  },
  lgOptions: {
    columnStart: et.inner7,
    columnEnd: i.rightInner
  },
  xlOptions: {
    columnStart: et.inner8,
    columnEnd: i.rightInner
  }
}), ae = () => ({
  options: {
    columnStart: i.leftOuter,
    columnEnd: i.rightOuter,
    topSpacing: "6vw"
  }
});
const q = "SplitStackSection", j = new $(q), ce = ({
  topSpacer: o,
  bottomSpacer: r,
  headline: a,
  mediaFrame: n,
  textGroup: s,
  className: e,
  componentId: l,
  theme: p = "white",
  sectionTransitionConfig: c = bt,
  componentOrderIdx: m = 0
}) => {
  const { ref: d, sectionId: N, disableTransitions: v } = gt(
    q,
    m
  ), { scrollProgress: C } = St(N), {
    isFirstInBackgroundTransition: x,
    backgroundTransition: I,
    isDisabled: w
  } = c, y = p, R = I || p, M = !!I, { sectionStyles: E } = Bt(
    C,
    [0, 0.5],
    [y, R],
    N,
    x
  ), S = st(), u = v || S || !M || w, A = u ? {} : E, _ = h(j.getComponentClassName(), e, {
    [`section-wrapper-transparent ${j.getElementClassName(
      "with-bg-transition"
    )}`]: !u
  });
  let g;
  (n == null ? void 0 : n.type) === "Image" && (g = n.image, g.maxSrcSetWidth = 3e3, g.imageServerKnobs = {
    quality: 100
  });
  const O = re(), Z = ie(), W = ae(), B = {
    options: {
      topSpacing: o,
      bottomSpacing: r,
      rowsGap: "none"
    }
  }, z = (f) => {
    let k = f;
    return Q(f) || (k = {
      textGroup: f
    }), /* @__PURE__ */ t(G, { ...O, children: /* @__PURE__ */ t(
      at,
      {
        className: j.getElementClassName("headlineContainer"),
        ...k,
        textGroup: {
          ...k.textGroup,
          analyticsCompName: q
        }
      }
    ) });
  }, H = (f) => /* @__PURE__ */ t(
    G,
    {
      ...W,
      role: "img",
      "aria-label": f.imageAltText,
      children: /* @__PURE__ */ t(
        nt,
        {
          ...n,
          type: "Image",
          image: f,
          mediaRatio: "12:5",
          baseMediaRatio: "1:1"
        }
      )
    }
  ), J = (f) => /* @__PURE__ */ t(
    G,
    {
      ...Z,
      className: j.getElementClassName("textContainer"),
      children: /* @__PURE__ */ t(Ct, { ...f, analyticsCompName: q })
    }
  );
  return /* @__PURE__ */ t(rt, { children: /* @__PURE__ */ X(
    it,
    {
      theme: p,
      id: l,
      ref: d,
      ...B,
      className: _,
      motion: "custom",
      motionProps: { style: A },
      children: [
        a && z(a),
        s && J(s),
        g && H(g)
      ]
    }
  ) });
}, le = "TextHeaderInnerBase", It = Xt(
  ({
    start: o = jt,
    span: r = qt,
    className: a,
    bottomSpacer: n,
    gridSpacings: s,
    children: e
  }, l) => {
    var m;
    const p = Yt(o, r), c = Ut(p, s);
    return c.options = {
      ...c.options,
      bottomSpacing: n ?? ((m = c.options) == null ? void 0 : m.bottomSpacing)
    }, /* @__PURE__ */ t(G, { className: a, ...c, ref: l, children: e });
  }
);
It.displayName = le;
const pe = "StackSection";
new $(pe);
const yt = ({
  alignment: o,
  mediaSize: r,
  mediaAlignment: a
}) => {
  let n = {};
  const s = {};
  let e = "Inner Rail";
  return a ? e = a : r && (r === "Large" ? e = "Edge Rail" : r === "Medium" ? e = "Outer Rail" : r === "Small" && (e = "Inner Rail")), o === "Start" ? n = {
    start: 1,
    span: 6
  } : o === "Center" && (n = {
    start: 3,
    span: 8
  }), e === "Edge Rail" ? s.options = {
    columnStart: i.leftEdge,
    columnEnd: i.rightEdge
  } : e === "Outer Rail" ? s.options = {
    columnStart: i.leftOuter,
    columnEnd: i.rightOuter
  } : e === "Inner Rail" && (s.options = {
    columnStart: i.leftInner,
    columnEnd: i.rightInner
  }), {
    startRow: n,
    endRow: s
  };
}, mt = {
  start: 0,
  end: 1
}, me = (o) => {
  const { scrollYProgress: r } = K({
    target: o,
    offset: ["start end", "start start"]
  });
  return { borderRadiusContainer: T(
    r,
    [mt.start, mt.end],
    ["2.5rem", "0rem"]
  ) };
}, de = (o) => {
  const r = {
    phoneMovingStart: 0.25,
    phoneMovingEnd: 1,
    textGroupMovingStart: 0.25,
    textGroupMovingEnd: 1
  }, { scrollYProgress: a } = K({
    target: o,
    offset: ["start start", "14%"]
  }), n = Vt(a, {
    stiffness: 150,
    mass: 1.8,
    damping: 120
  }), s = T(
    n,
    [r.textGroupMovingStart, r.textGroupMovingEnd],
    ["50%", "0%"]
  ), e = T(
    n,
    [r.textGroupMovingStart, r.textGroupMovingEnd],
    ["-50%", "0%"]
  );
  return {
    scrollYProgressScrub: n,
    textGroupScrubbingAnimation: {
      top: s,
      y: e
    }
  };
}, ue = () => ({
  options: {
    topSpacing: "8vw"
  },
  mdOptions: {
    topSpacing: "16vw"
  },
  lgOptions: {
    topSpacing: "8vw"
  }
}), ge = {
  "stack-scrubbing-video": "_stack-scrubbing-video_o5a9e_1",
  "stack-scrubbing-video-sticky-container": "_stack-scrubbing-video-sticky-container_o5a9e_8",
  "stack-scrubbing-video-text-group-grid": "_stack-scrubbing-video-text-group-grid_o5a9e_18",
  "stack-scrubbing-video-text-group-animation": "_stack-scrubbing-video-text-group-animation_o5a9e_22",
  "stack-scrubbing-video-background": "_stack-scrubbing-video-background_o5a9e_25",
  "stack-scrubbing-video-reduce-motion": "_stack-scrubbing-video-reduce-motion_o5a9e_43"
}, Gt = "StackScrubbingVideo", P = new $(Gt, ge), Se = L.div, fe = L.section, be = ({
  headline: o,
  className: r,
  alignment: a = "Center",
  disclosureType: n,
  theme: s = "stone",
  componentId: e,
  backgroundMediaFrame: l,
  ...p
}) => {
  const c = Nt(null), [m] = ft(["Below MD"]), d = st(), { borderRadiusContainer: N } = me(c), { scrollYProgressScrub: v, textGroupScrubbingAnimation: C } = de(c), x = h(P.getComponentClassName(), r, {
    [P.getElementClassName("reduce-motion")]: d
  }), I = yt({
    mediaAlignment: "Inner Rail",
    alignment: a
  }), w = m || d, y = {
    rowsGap: "none"
  }, R = w ? {} : ut({
    "--border-radius-section-grid": N
  }), M = (S) => {
    let u = S;
    return Q(S) || (u = {
      ...I.startRow,
      textGroup: S
    }), /* @__PURE__ */ t(
      It,
      {
        ...u,
        className: h(
          u.className,
          P.getElementClassName("text-group-grid")
        ),
        gridSpacings: ue(),
        children: /* @__PURE__ */ t(
          Se,
          {
            className: P.getElementClassName("text-group-animation"),
            style: C,
            children: /* @__PURE__ */ t(
              Kt,
              {
                ...u.textGroup,
                alignment: a,
                analyticsCompName: Gt
              }
            )
          }
        )
      }
    );
  }, E = () => (l == null ? void 0 : l.type) === "Video" ? /* @__PURE__ */ t(
    Lt,
    {
      scrollYProgress: v,
      backgroundAnimation: l.video,
      reduceMotion: d,
      className: P.getElementClassName("background"),
      maxSrcSetWidth: Wt.xl2Image
    }
  ) : /* @__PURE__ */ t("div", {});
  return /* @__PURE__ */ t(rt, { children: /* @__PURE__ */ t(fe, { className: x, ref: c, style: R, children: /* @__PURE__ */ X(
    Dt,
    {
      as: "div",
      className: P.getElementClassName("sticky-container"),
      disclosure: n,
      options: y,
      theme: s,
      isThemeEnabled: !0,
      id: e,
      ...p,
      children: [
        o && M(o),
        E()
      ]
    }
  ) }) });
};
const ct = "StackSection", dt = new $(ct), Ne = ({
  headline: o,
  mediaSize: r,
  mediaAlignment: a,
  className: n,
  mediaFrame: s,
  alignment: e = "Start",
  disclosureType: l,
  topSpacer: p = "6vw",
  bottomSpacer: c = "6vw",
  theme: m,
  componentId: d,
  backgroundMediaFrame: N,
  animationType: v = "default",
  variant: C,
  isParallaxEnabled: x = !1,
  textGroup: I,
  sectionTransitionConfig: w,
  componentContext: y = {},
  ...R
}) => {
  const { componentOrderIdx: M = 0 } = y, E = {
    topSpacing: p,
    bottomSpacing: c,
    rowsGap: "none"
  }, S = Ht({
    ...s,
    mediaRatio: (s == null ? void 0 : s.mediaRatio) ?? "16:9",
    baseMediaRatio: (s == null ? void 0 : s.baseMediaRatio) ?? "1:1"
  }), u = yt({
    mediaSize: r,
    mediaAlignment: a,
    alignment: e
  }), A = h(dt.getComponentClassName(), n), _ = (g) => {
    let O = g;
    return Q(g) || (O = {
      ...u.startRow,
      textGroup: g
    }), /* @__PURE__ */ t(
      at,
      {
        className: dt.getElementClassName("row-spacing"),
        ...O,
        textGroup: {
          ...O.textGroup,
          alignment: e,
          analyticsCompName: ct
        }
      }
    );
  };
  return N ? /* @__PURE__ */ t(
    be,
    {
      headline: o,
      alignment: e,
      backgroundMediaFrame: N,
      theme: m,
      disclosureType: l,
      componentId: d
    }
  ) : C === "featured" ? /* @__PURE__ */ t(
    se,
    {
      alignment: e,
      topSpacer: p,
      bottomSpacer: c,
      disclosureType: l,
      headline: o,
      mediaFrame: s,
      textGroup: I,
      isParallaxEnabled: x,
      className: n,
      componentId: d,
      theme: m,
      componentOrderIdx: M
    }
  ) : C === "splitText" ? /* @__PURE__ */ t(
    ce,
    {
      topSpacer: p,
      bottomSpacer: c,
      headline: o,
      mediaFrame: s,
      textGroup: I,
      className: n,
      componentId: d,
      theme: m,
      sectionTransitionConfig: w,
      componentOrderIdx: M
    }
  ) : /* @__PURE__ */ X(
    it,
    {
      className: A,
      disclosure: l,
      options: E,
      theme: m,
      id: d,
      ...R,
      children: [
        o && _(o),
        S && /* @__PURE__ */ t(G, { ...u.endRow, children: /* @__PURE__ */ t(
          Ft,
          {
            animationType: v,
            mediaFrameProps: S
          }
        ) })
      ]
    }
  );
};
Ne.displayName = ct;
export {
  Ne as default
};
//# sourceMappingURL=StackSectionType.js.map
